<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>


                    <CCardBody >
                        <!--                        <ReportGrid :fields="fields" :items="items_customer"/>-->

                        <BuyReportOnePerson/>

                    </CCardBody>


                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from "vue";
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import BTabs from "../../tabs/BTabs";

    import BuyReportAllSuppliers from "../orders/BuyReportAllSuppliers";
    import BuyReportOnePerson from "../orders/BuyReportOnePerson";
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    export default {
        name: 'Login',
        components: {
            Treeselect,
            BuyReportAllSuppliers,
            BuyReportOnePerson,
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                VUE_APP_Currency: localStorage.getItem('currency'),

            }
        }, mounted() {

            this.$root.root_validate_errors = [];
            // this.get_lists_groups();
            // this.get_types();


        }, watch: {
            'selected_tafsili': function () {
                // this.get_lists();
            }
        },
        methods: {

        }
    }

</script>
<style>
    .height-2000  {
        height: 300px !important;
    }
</style>
